
import React, {useEffect, useState} from "react";
import SVG from "react-inlinesvg";
import { Modal, Form, Col } from "react-bootstrap";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../../../../../../../../../_metronic/_helpers";
import * as handlers from "../../../../../../../../_redux/selected-user/selectedUserHandlers"
import { useParams } from "react-router-dom";
import cogoToast from "cogo-toast";
import { useAddTransactionMutation } from "../../../../../../../../../../../redux/apiSlice";
import { ucFirst } from "../../../../../../../../../../util/Helpers";

const AddTransactionModal = ({showAddTransactionModal, onHide, currency, partner}) => {

    const dispatch = useDispatch();
    const {userId, accountId} = useParams();
    const [validated, setValidated] = useState(false);
    const [ addTransaction, { isLoading, isSuccess }] = useAddTransactionMutation();
    const profile = useSelector(({selectedUser}) => selectedUser.data?.profile, shallowEqual);
      
    // Create Transaction for User
    const handleSubmitWithdrawal = e => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            const formData = new FormData(form);
            const data = {...Object.fromEntries(formData.entries()), userId, accountId};
            data.meta = {...profile.basic, currency}
            addTransaction(data);
        }
        setValidated(true);
    }

    /* Close Modal on Success */
    useEffect(() => {
        if (isSuccess) {
            cogoToast.success("Transaction Added Successfully"); 
            onHide();
            dispatch(handlers.fetchUserAccountDetails(userId, accountId)); 
        }
    }, [isSuccess, onHide, dispatch, accountId, userId]);

  return (
    <Modal
        show={showAddTransactionModal}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        onExited={_ => setValidated(false)}
      >
      
        <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmitWithdrawal}
        >
            <Modal.Header >
            <Modal.Title id="contained-modal-title-vcenter">
                
                <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/General/Expand-arrows.svg")}
                    />
                </span>
                Add New Transaction Record
            </Modal.Title>
            <button type="button" className="close" onClick={onHide}>
                <span aria-hidden="true" className="d-block">×</span>
                <span className="sr-only">Close</span>
            </button>
            </Modal.Header>
            <Modal.Body 
                className="px-10 py-2"
            >
            <div className="row mt-5">
                <div className="col-lg-4 pr-5">
                    <h6 className="mb-0 pt-3">Account*</h6>
                </div>                   
                <Form.Group as={Col} controlId="partner">
                    <Form.Control
                        type="text"
                        value={ucFirst(partner)}
                        readOnly={true}
                    />
                </Form.Group>
            </div>
                <div className="row">
                    <div className="col-lg-4 pr-5">
                        <h6 className="mb-0 pt-3">User ID*</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="userId">
                        <Form.Control
                            required
                            type="text"
                            name="userId"
                            value={userId}
                            readOnly={true}
                        />
                    </Form.Group>
                </div>
                <div className="row">
                    <div className="col-lg-4 pr-5">
                        <h6 className="mb-0 pt-3">Account ID*</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="accountId">
                        <Form.Control
                            required
                            type="text"
                            name="accountId"
                            value={accountId}
                            readOnly={true}
                        />
                    </Form.Group>
                </div>
                <div className="row">
                    <div className="col-lg-4 pr-5">
                        <h6 className="mb-0 pt-3">Reference</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="refId">
                        <Form.Control
                            type="text"
                            name="refId"
                        />
                    </Form.Group>
                </div>
                <div className="row">
                    <div className="col-lg-4 pr-5">
                        <h6 className="mb-0 pt-3">Type*</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="type">
                        <Form.Control
                            required
                            as="select"
                            className="mr-sm-2"
                            custom
                            name="transactionType"
                        >
                            <option value="DEPOSIT">Deposit</option>
                            <option value="WITHDRAW">Withdraw</option>
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Select Transaction Type
                        </Form.Control.Feedback>
                    </Form.Group>
                </div>
                
                <div className="row">
                    <div className="col-lg-4 pr-5">
                        <h6 className="mb-0 pt-3">Amount in {currency}*</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="amount">
                        <Form.Control
                            required
                            type="text"
                            name="tranAmount"
                            pattern="^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$"
                            autoComplete="off"
                        />
                        <Form.Control.Feedback type="invalid">
                            Enter Valid Amount
                        </Form.Control.Feedback>
                    </Form.Group>
                </div>

                <div className="row">
                    <div className="col-lg-4 pr-5">
                        <h6 className="mb-0 pt-3">Comment*</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="bankRef">
                        <Form.Control
                            required
                            as="textarea"
                            name="comment"
                            autoComplete="off"
                            minLength={4}
                        />
                        <Form.Control.Feedback type="invalid">
                            Enter Transaction Comment
                        </Form.Control.Feedback>
                    </Form.Group>
                </div>
                
            </Modal.Body>
            <Modal.Footer className="justify-content-centerx">
                <button
                    type="button"
                    onClick={onHide}
                    disabled={isLoading}
                    className="btn btn-light btn-elevate px-4"
                >
                    Cancel
                </button>
                <> </>
                <button
                    type="submit"
                    disabled={isLoading}
                    className="btn btn-primary btn-elevate px-4 ml-4"
                >
                    Add Transaction
                </button>
            </Modal.Footer>
        </Form>
      </Modal>

        );
}

export default AddTransactionModal;